export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "page",
  computed: {
    message() {
      return "The webmaster said that you can not enter this page...";
    }
  }
};